// @ts-nocheck
// Peças visuais dos cards das etapas (hierarquia do canvas de 28/10/2026):
// quem → selo → título e frase → aviso → dois blocos → barra → ação
// principal → lista do que falta (o que está ok recolhido) → ajuda.
import React, { useState } from "react";
import styled, { css } from "styled-components";

import CheckIcon from "@material-ui/icons/Check";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

export const Corpo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 16px;

  .desc {
    font-size: 15px;
    line-height: 23px;
    color: var(--cinza-80);
    margin: 0;
  }
`;

const selos = {
  cliente: css`
    background: var(--atencao-10);
    color: #7a5200;
    i { background: var(--atencao-50); }
  `,
  equipe: css`
    background: var(--principal-10);
    color: #1a6b2a;
    i { background: var(--principal-50); }
  `,
  obstaculo: css`
    background: var(--erro-10);
    color: var(--secundaria-dark);
    i { background: var(--erro-50); }
  `,
  concluido: css`
    background: var(--principal-50);
    color: var(--white);
  `,
  neutro: css`
    background: var(--cinza-20);
    color: var(--cinza-90);
    i { background: var(--cinza-70); }
  `,
};

const SeloBase = styled.span`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 1px;

  i {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    display: block;
  }

  svg {
    font-size: 13px;
  }

  ${({ tipo }) => selos[tipo] || selos.equipe}
`;

const TEXTO_SELO = {
  cliente: "SUA VEZ",
  equipe: "COM A GENTE",
  obstaculo: "OBSTÁCULO",
  concluido: "CONCLUÍDO",
};

export function Selo({ tipo, children }) {
  return (
    <SeloBase tipo={tipo}>
      {tipo === "concluido" ? <CheckIcon /> : <i />}
      {children || TEXTO_SELO[tipo]}
    </SeloBase>
  );
}

export const Titulo = styled.h4`
  font-size: var(--font-19);
  line-height: 1.3;
  font-weight: 900;
  color: var(--cinza-100);
  margin: 0;
`;

const avisos = {
  cliente: css`
    background: var(--atencao-10);
    b { color: #7a5200; }
  `,
  obstaculo: css`
    background: var(--erro-10);
    b { color: var(--secundaria-dark); }
  `,
  equipe: css`
    background: var(--principal-10);
    b { color: #1a6b2a; }
  `,
  neutro: css`
    background: var(--cinza-20);
    b { color: var(--cinza-100); }
  `,
};

// Aviso colorido com texto curto (atraso, motivo do obstáculo, etc.).
export const Aviso = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
  line-height: 20px;
  color: var(--cinza-80);

  p {
    margin: 0;
  }

  ${({ tipo }) => avisos[tipo] || avisos.neutro}
`;

// "Também com você": outra pendência do cliente fora desta etapa.
export const AvisoLink = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--atencao-30);
  background: var(--atencao-10);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 20px;
  color: var(--cinza-90);
  text-decoration: none;

  i {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--atencao-50);
    flex-shrink: 0;
  }

  b {
    color: #7a5200;
  }

  &:hover {
    border-color: var(--atencao-50);
  }
`;

export const Blocos = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
`;

const BlocoBase = styled.div`
  background: var(--cinza-20);
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  small {
    font-size: 13px;
    color: var(--cinza-70);
  }

  strong {
    font-size: 15px;
    line-height: 20px;
    color: var(--cinza-100);
    font-weight: 900;
    overflow-wrap: anywhere;
  }

  s {
    color: var(--cinza-70);
    font-weight: 400;
  }
`;

export function Bloco({ rotulo, children }) {
  return (
    <BlocoBase>
      <small>{rotulo}</small>
      <strong>{children}</strong>
    </BlocoBase>
  );
}

const ProgressoBase = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .topo {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    font-size: 13px;
    font-weight: 700;
    color: var(--cinza-100);
  }

  .topo span:last-child {
    font-weight: 400;
    color: var(--cinza-70);
  }

  .barra {
    height: 8px;
    border-radius: 999px;
    background: var(--cinza-30);
    overflow: hidden;
  }

  .barra div {
    height: 100%;
    background: var(--principal-50);
    border-radius: 999px;
  }
`;

export function Progresso({ rotulo, percentual }) {
  const p = Math.max(0, Math.min(100, Math.round(Number(percentual) || 0)));
  return (
    <ProgressoBase>
      <div className="topo">
        <span>{rotulo}</span>
        <span>{p}%</span>
      </div>
      <div className="barra" role="progressbar" aria-valuenow={p} aria-valuemin={0} aria-valuemax={100}>
        <div style={{ width: `${p}%` }} />
      </div>
    </ProgressoBase>
  );
}

const botao = css`
  min-height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  font: 700 15px Lato, sans-serif;
  cursor: pointer;
  width: 100%;
  text-decoration: none;
  text-align: center;

  svg {
    font-size: 18px;
    flex-shrink: 0;
  }

  &:disabled,
  &[aria-disabled="true"] {
    opacity: 0.6;
    cursor: wait;
  }

  ${({ secundario }) =>
    secundario
      ? css`
          background: var(--white);
          color: var(--cinza-90);
          border: 1px solid var(--cinza-40);

          &:hover {
            border-color: var(--cinza-70);
          }
        `
      : css`
          background: var(--neutro-30);
          color: var(--white);
          border: 1px solid var(--neutro-30);

          &:hover {
            background: var(--neutro-40);
          }
        `}
`;

export const Botao = styled.button`
  ${botao}
`;

export const BotaoLink = styled.a`
  ${botao}
`;

// Botão que abre o seletor de arquivo (o <input> fica escondido dentro).
export const BotaoArquivo = styled.label`
  ${botao}
  position: relative;

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
  }

  &:focus-within {
    outline: 2px solid var(--principal-50);
    outline-offset: 2px;
  }
`;

export const LinkTexto = styled.a`
  align-self: flex-start;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 0;
  padding: 0;
  font: 700 14px Lato, sans-serif;
  color: var(--neutro-40);
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: var(--principal-50);
  }

  svg {
    font-size: 18px;
  }
`;

export const Secao = styled.p`
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--cinza-70);
  margin: 8px 0 0;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--cinza-30);
`;

export const Itens = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

const icones = {
  cliente: css`background: var(--atencao-10); color: #7a5200;`,
  erro: css`background: var(--erro-10); color: var(--erro-50);`,
  ok: css`background: var(--principal-10); color: var(--principal-50);`,
  neutro: css`background: var(--cinza-20); color: var(--cinza-80);`,
};

const ItemBase = styled.li`
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--cinza-20);

  &:last-child {
    border-bottom: 0;
  }

  .ic {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
      font-size: 16px;
    }

    ${({ tipo }) => icones[tipo] || icones.neutro}
  }

  .txt {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex-grow: 1;
  }

  .txt > b {
    font-size: 15px;
    color: var(--cinza-100);
  }

  .txt > small {
    font-size: 13px;
    line-height: 18px;
    color: var(--cinza-70);
  }

  .motivo {
    font-size: 13px;
    line-height: 18px;
    color: var(--secundaria-dark);
  }
`;

export function Item({ tipo, icone, titulo, descricao, children }) {
  return (
    <ItemBase tipo={tipo}>
      <span className="ic">{icone}</span>
      <div className="txt">
        <b>{titulo}</b>
        {descricao && <small>{descricao}</small>}
        {children}
      </div>
    </ItemBase>
  );
}

const etiquetas = {
  cliente: css`background: var(--atencao-10); color: #7a5200;`,
  equipe: css`background: var(--principal-10); color: #1a6b2a;`,
  erro: css`background: var(--erro-10); color: var(--secundaria-dark);`,
  neutro: css`background: var(--cinza-20); color: var(--cinza-80);`,
};

export const Etiqueta = styled.span`
  align-self: flex-start;
  font-size: 12px;
  font-weight: 700;
  border-radius: 4px;
  padding: 2px 8px;
  ${({ tipo }) => etiquetas[tipo] || etiquetas.neutro}
`;

const RecolhidoBotao = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid var(--cinza-30);
  border-radius: 10px;
  padding: 12px 14px;
  min-height: 48px;
  background: var(--white);
  font: 700 14px Lato, sans-serif;
  color: var(--cinza-100);
  cursor: pointer;
  width: 100%;
  text-align: left;

  span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .ok {
    color: var(--principal-50);
    font-size: 18px;
  }

  .seta {
    color: var(--cinza-80);
    transition: transform 0.2s;
  }

  &[aria-expanded="true"] .seta {
    transform: rotate(180deg);
  }
`;

// Lista que começa fechada ("5 documentos já recebidos").
export function Recolhido({ rotulo, icone, children }) {
  const [aberto, setAberto] = useState(false);
  return (
    <>
      <RecolhidoBotao type="button" aria-expanded={aberto} onClick={() => setAberto(!aberto)}>
        <span>
          {icone === undefined ? <CheckIcon className="ok" /> : icone}
          {rotulo}
        </span>
        <ExpandMoreIcon className="seta" />
      </RecolhidoBotao>
      {aberto && children}
    </>
  );
}

const AjudaBase = styled.div`
  background: var(--cinza-20);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;

  h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 900;
    color: var(--cinza-100);
  }

  ol {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  li,
  p {
    display: flex;
    gap: 10px;
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: var(--cinza-80);
  }

  li b {
    color: var(--cinza-100);
  }

  .num {
    width: 22px;
    height: 22px;
    border-radius: 6px;
    background: var(--cinza-30);
    color: var(--cinza-90);
    font-size: 12px;
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .num.feito {
    background: var(--principal-50);
    color: var(--white);

    svg {
      font-size: 14px;
    }
  }
`;

// Caixa cinza do fim do card. `passos`: [{ texto, feito? }] ou textos.
export function Ajuda({ titulo, passos = [], children }) {
  return (
    <AjudaBase>
      <h5>{titulo}</h5>
      {passos.length > 0 && (
        <ol>
          {passos.map((passo, i) => {
            const { texto, feito } = typeof passo === "object" && passo?.texto ? passo : { texto: passo };
            return (
              <li key={i}>
                <span className={`num ${feito ? "feito" : ""}`}>{feito ? <CheckIcon /> : i + 1}</span>
                <span>{texto}</span>
              </li>
            );
          })}
        </ol>
      )}
      {children}
    </AjudaBase>
  );
}

const CampoBase = styled.div`
  background: var(--cinza-20);
  border-radius: 10px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  small {
    display: block;
    font-size: 12px;
    color: var(--cinza-70);
  }

  strong {
    font: 600 15px monospace;
    color: var(--cinza-100);
    overflow-wrap: anywhere;
  }

  em {
    font-style: normal;
    font-size: 14px;
    color: var(--cinza-70);
  }

  button {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    border: 1px solid var(--cinza-40);
    background: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    color: var(--cinza-80);
  }

  button.copiado {
    border-color: var(--principal-50);
    color: var(--principal-50);
  }
`;

// Valor com botão de copiar (senha, código de rastreio).
export function Campo({ rotulo, valor, vazio, iconeVazio }) {
  const [copiado, setCopiado] = useState(false);
  const copiar = () => {
    if (!navigator.clipboard?.writeText) return;
    navigator.clipboard.writeText(valor).then(() => {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 1500);
    });
  };
  return (
    <CampoBase>
      <div style={{ minWidth: 0 }}>
        <small>{rotulo}</small>
        {valor ? <strong>{valor}</strong> : <em>{vazio}</em>}
      </div>
      {valor ? (
        <button type="button" className={copiado ? "copiado" : ""} aria-label={`Copiar ${rotulo.toLowerCase()}`} onClick={copiar}>
          {copiado ? <CheckIcon fontSize="small" /> : <FileCopyOutlinedIcon fontSize="small" />}
        </button>
      ) : (
        iconeVazio || null
      )}
    </CampoBase>
  );
}

// Arquivo já enviado (comprovante).
export const Arquivo = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--cinza-30);
  border-radius: 10px;
  padding: 10px 12px;
  text-decoration: none;
  color: inherit;

  .ic {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    background: var(--principal-10);
    color: var(--principal-50);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
      font-size: 16px;
    }
  }

  div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  b {
    font-size: 14px;
    color: var(--cinza-100);
    overflow-wrap: anywhere;
  }

  small {
    font-size: 12px;
    color: var(--cinza-70);
  }
`;

// "2026-09-29T00:00:00.000000Z" -> "29/09" (sem converter fuso).
export const diaMes = (data) => {
  const [, mes, dia] = String(data || "").slice(0, 10).split("-");
  return dia && mes ? `${dia}/${mes}` : null;
};

// Dia corrido de uma etapa entre início e fim previstos.
export function diasDaEtapa(inicio, fim) {
  if (!inicio || !fim) return null;
  const um = 24 * 60 * 60 * 1000;
  const dia = (d) => {
    const [a, m, x] = String(d).slice(0, 10).split("-").map(Number);
    return new Date(a, m - 1, x).getTime();
  };
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const total = Math.max(1, Math.round((dia(fim) - dia(inicio)) / um));
  const atual = Math.round((hoje.getTime() - dia(inicio)) / um) + 1;
  return { atual: Math.max(1, atual), total, atrasado: atual > total, percentual: (Math.max(0, atual) / total) * 100 };
}

export const WHATSAPP = "5521990257203";
export const linkWhatsApp = (texto) => `https://api.whatsapp.com/send?phone=${WHATSAPP}&text=${encodeURIComponent(texto)}`;
